"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullObj = void 0;
function nullObj() {
    var x = {};
    x.__proto__ = null;
    return x;
}
exports.nullObj = nullObj;
//# sourceMappingURL=utils.js.map